import { Component } from '@angular/core';

@Component({
  selector: 'app-root-redirect',
  template: ''
})
export class RootRedirectComponent {}
